import React, { Component } from 'react';
import Moment from 'moment';
import 'moment-duration-format'

export default class StatusTable extends Component {
  getStatusLabel(status) {
    let statusLabel;

    switch(status.code) {
      case "delivery":
        statusLabel = "Delivered";
        break;
      case "encode":
        statusLabel = "Encoded";
        break;
      case "error":
        statusLabel = "Error";
        break;
      case "new":
        statusLabel = "New";
        break;
      default:
        statusLabel = status.label;
    }

    return statusLabel;
  }
  getStatusStyleClass(status, elementType) {
    let statusStyleClass;

    switch(status.code) {
      case "delivery":
        statusStyleClass = elementType + "-success";
        break;
      case "encode":
        statusStyleClass = elementType + "-warning";
        break;
      case "error":
        statusStyleClass = elementType + "-danger";
        break;
      case "new":
        statusStyleClass = elementType + "-info";
        break;
      default:
        statusStyleClass = elementType + "-default";
    }

    return statusStyleClass;
  }
  getMetric(metricToGet, metricsToSearch) {
    return metricsToSearch.filter((metric) => { return metric.code === metricToGet })[0].val;
  }
  formatSecondsMetric(seconds, status) {
    return (status.code === "error" ? "--" : Moment.duration(seconds, 's').format('d[d] h[h] m[m] s[s]'));
  }
  render() {
    return (
      <div>
        <div className="col-md-12">
          <div className="status-table panel panel-default">
            <div className="panel-heading">{this.props.storeName + " (" + this.props.dateRangeName + ")"}</div>
              <div className="row">
                {
                  this.props.statuses.map((status, index) => {
                    return (
                      <div key={index} className="col-md-3">
                        <div className={"dash-feature " + this.getStatusStyleClass(status, "dash-feature")}>
                          <span>{status.totalCnt}</span>
                          <div>{"Total " + this.getStatusLabel(status)}</div>
                        </div>
                      </div>
                    );
                  })
                }
              </div>
          </div>
        </div>
        {
          this.props.statuses.map((status, index) => {
            return (
              <div key={index} className="col-md-6">
                <div className={"status-table panel " + this.getStatusStyleClass(status, "panel")}>
                  <div className="panel-heading">{this.getStatusLabel(status)}</div>
                  <table className="table">
                    <thead>
                      <tr>
                        <th>
                          Status
                        </th>
                        <th>
                          #
                        </th>
                        <th>
                          Average Time
                        </th>
                        <th>
                          Min.
                        </th>
                        <th>
                          Max.
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      {
                        status.priorities.map((priority, priorityIndex) => {
                          let metrics = priority.metrics;
                          return (
                            <tr key={priorityIndex}>
                              <td>
                                {priority.label}
                              </td>
                              <td>
                                {this.getMetric("cnt", metrics)}
                              </td>
                              <td>
                                {this.formatSecondsMetric(this.getMetric("avg", metrics), status)}
                              </td>
                              <td>
                                {this.formatSecondsMetric(this.getMetric("min", metrics), status)}
                              </td>
                              <td>
                                {this.formatSecondsMetric(this.getMetric("max", metrics), status)}
                              </td>
                            </tr>
                          );
                        })
                      }
                    </tbody>
                  </table>
                </div>
              </div>
            );
          })
        }
      </div>
    );
  }
}



/** WEBPACK FOOTER **
 ** ./src/components/status-table.js
 **/